import React from 'react'

import SocialIcon from '@components/myScores/SocialIcon'
import Product from '@models/Product'
import Score from '@models/Score'
import { isScore } from '@models/util/score.util'

interface Props {
  score: Score | Product
}

const SocialSection: React.FC<Props> = ({ score }: Props) => {
  return (
    <div className="basis-[120px] flex flex-row items-center gap-1.5">
      <SocialIcon type="favorites" count={score.favorites_count ?? 0} className="flex-1" />
      <SocialIcon type="views" count={score.views_count} className="flex-1" />

      {/* Comments (score only) */}
      {isScore(score) && (
        <SocialIcon type="comments" count={score.comments_count} className="flex-1 mr-0" />
      )}
    </div>
  )
}

export default SocialSection
